import Scaffold from '~/components/Scaffold';

export const AppGroupPermissions = () => {
  return <Scaffold title="Edit permission" withBg={false} />;
};
